module.exports = __webpack_public_path__ + "static/media/esports-page-grid-6.e9a3c13e.jpg";